(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────
     LOADING SCREEN
     Shows 'kvlr.' on black for 1.5s, fades out, then starts
     typewriter. Uses sessionStorage so it only runs once.
     ───────────────────────────────────────────────────────────── */
  function initLoader() {
    var loader = document.getElementById('kvlr-loader');

    function afterLoad() {
      document.documentElement.classList.add('kvlr-loaded');
      initTypewriter();
    }

    if (!loader) { afterLoad(); return; }

    if (sessionStorage.getItem('kvlr-v')) {
      loader.remove();
      afterLoad();
      return;
    }

    setTimeout(function () {
      loader.classList.add('kvlr-loader--out');
      sessionStorage.setItem('kvlr-v', '1');
      setTimeout(function () {
        loader.remove();
        afterLoad();
      }, 860);
    }, 1500);
  }

  /* ─────────────────────────────────────────────────────────────
     TYPEWRITER
     Reveals hero heading letter by letter, then fades in button.
     ───────────────────────────────────────────────────────────── */
  function initTypewriter() {
    var el = document.querySelector('[data-kvlr-typewriter]');
    if (!el) return;

    var text = el.getAttribute('data-text') || el.textContent.trim();
    el.textContent = '';
    el.style.opacity = '1';

    var cur = document.createElement('span');
    cur.className = 'kvlr-type-cursor';
    cur.textContent = '|';
    el.appendChild(cur);

    var i = 0;

    function type() {
      if (i < text.length) {
        el.insertBefore(document.createTextNode(text[i++]), cur);
        setTimeout(type, 100);
      } else {
        cur.classList.add('kvlr-type-cursor--blink');

        setTimeout(function () {
          cur.style.transition = 'opacity 0.6s ease';
          cur.style.opacity = '0';
          setTimeout(function () { cur.remove(); }, 650);
        }, 2200);

        var btn = document.querySelector('.kvlr-hero__button');
        if (btn) {
          btn.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
          btn.style.opacity = '1';
          btn.style.transform = 'translateY(0)';
        }
      }
    }

    setTimeout(type, 200);
  }

  /* ─────────────────────────────────────────────────────────────
     CURSOR RING
     8px hollow circle that follows mouse with lerp delay.
     System cursor remains fully visible at all times.
     ───────────────────────────────────────────────────────────── */
  function initCursor() {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    var ring = document.createElement('div');
    ring.className = 'kvlr-cursor-ring';
    document.body.appendChild(ring);

    var mx = -300, my = -300;
    var rx = -300, ry = -300;

    document.addEventListener('mousemove', function (e) {
      mx = e.clientX;
      my = e.clientY;
    });

    (function tick() {
      rx += (mx - rx) * 0.1;
      ry += (my - ry) * 0.1;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(tick);
    })();
  }

  /* ─────────────────────────────────────────────────────────────
     SCROLL ANIMATIONS  [data-kvlr-animate]
     Fade + slide-up, 0.8s ease-out. Supports data-kvlr-delay.
     ───────────────────────────────────────────────────────────── */
  function initScrollAnimations() {
    var targets = document.querySelectorAll('[data-kvlr-animate]');
    if (!targets.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseFloat(el.getAttribute('data-kvlr-delay') || 0) * 1000;
        setTimeout(function () { el.classList.add('kvlr-in'); }, delay);
        obs.unobserve(el);
      });
    }, { threshold: 0.12 });

    targets.forEach(function (el) { obs.observe(el); });
  }

  /* ─────────────────────────────────────────────────────────────
     TEXT REVEAL  [data-kvlr-reveal]
     Clip-path wipe from left to right.
     ───────────────────────────────────────────────────────────── */
  function initTextReveal() {
    var targets = document.querySelectorAll('[data-kvlr-reveal]');
    if (!targets.length) return;

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kvlr-revealed');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.08 });

    targets.forEach(function (el) { obs.observe(el); });
  }

  /* ─────────────────────────────────────────────────────────────
     PARALLAX  [data-parallax-speed]
     Branches move at different speeds relative to scroll center.
     ───────────────────────────────────────────────────────────── */
  function initParallax() {
    var section = document.querySelector('.kvlr-manifesto');
    if (!section) return;
    var items = section.querySelectorAll('[data-parallax-speed]');
    if (!items.length) return;

    function update() {
      var rect = section.getBoundingClientRect();
      var centerOffset = (rect.top + rect.height / 2) - window.innerHeight / 2;
      items.forEach(function (item) {
        var speed = parseFloat(item.getAttribute('data-parallax-speed') || 0);
        item.style.transform = 'translateY(' + (centerOffset * speed) + 'px)';
      });
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  /* ─────────────────────────────────────────────────────────────
     SECTION SEPARATORS
     Thin olive line injected between sections, draws on scroll.
     ───────────────────────────────────────────────────────────── */
  function initSeparators() {
    var anchors = [
      document.getElementById('shopify-section-kvlr_manifesto'),
      document.getElementById('shopify-section-featured_collection')
    ];

    anchors.filter(Boolean).forEach(function (section) {
      var sep = document.createElement('div');
      sep.className = 'kvlr-separator';
      section.after(sep);
    });

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kvlr-in');
        obs.unobserve(entry.target);
      });
    }, { threshold: 0.5 });

    document.querySelectorAll('.kvlr-separator').forEach(function (el) {
      obs.observe(el);
    });
  }

  /* ─────────────────────────────────────────────────────────────
     INIT
     ───────────────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initLoader();
    initCursor();
    initScrollAnimations();
    initTextReveal();
    initParallax();
    initSeparators();
  });
})();
